import { Input } from '@iwoca/orion';
import { useFormContext } from 'react-hook-form';

import styles from './PostcodeInput.module.css';
import { TPersonalDetailsDataUK } from '../../PersonalDetailsUK';

type TProps = {
  addressIndex: number;
};

export const ManualAddressInput = ({ addressIndex }: TProps) => {
  const {
    register,
    setValue,
    formState: { errors },
  } = useFormContext<TPersonalDetailsDataUK>();

  const INDEXED_ADDRESS = `residentialAddresses.${addressIndex}` as const;
  const CURRENT_ADDRESS_ERRORS = errors?.residentialAddresses?.[addressIndex];

  const clearEquifaxToken = () => {
    setValue(`${INDEXED_ADDRESS}.equifaxToken`, undefined);
  };

  return (
    <div className={styles.formFieldContainer} onChange={clearEquifaxToken}>
      <div className={styles.formFieldGroup}>
        <div className={`${styles.formField} fs-mask`}>
          <Input
            {...register(`${INDEXED_ADDRESS}.houseNumber`)}
            label="House number"
            error={CURRENT_ADDRESS_ERRORS?.houseNumber?.message}
          />
        </div>
        <div className={`${styles.formField} fs-mask`}>
          <Input
            {...register(`${INDEXED_ADDRESS}.houseName`)}
            label="House name"
            error={CURRENT_ADDRESS_ERRORS?.houseName?.message}
          />
        </div>
      </div>
      <div className={`${styles.formField} fs-mask`}>
        <Input
          {...register(`${INDEXED_ADDRESS}.streetLine1`)}
          label="Address Line 1"
          error={CURRENT_ADDRESS_ERRORS?.streetLine1?.message}
        />
      </div>
      <div className={`${styles.formField} fs-mask`}>
        <Input
          {...register(`${INDEXED_ADDRESS}.streetLine2`)}
          label="Address Line 2"
          error={CURRENT_ADDRESS_ERRORS?.streetLine2?.message}
        />
      </div>
      <div className={styles.formFieldGroup}>
        <div className={`${styles.formField} fs-mask`}>
          <Input
            {...register(`${INDEXED_ADDRESS}.town`)}
            label="Town/City"
            error={CURRENT_ADDRESS_ERRORS?.town?.message}
          />
        </div>
        <div className={`${styles.formField} fs-mask`}>
          <Input
            {...register(`${INDEXED_ADDRESS}.postcode`)}
            label="Postcode"
            error={CURRENT_ADDRESS_ERRORS?.postcode?.message}
          />
        </div>
      </div>
    </div>
  );
};
